import { Separator } from "./ui/separator";

const HeadingTitleItem = ({
	title,
	subTitle,
}: {
	title: string;
	subTitle: string;
}) => {
	return (
		<div className="text-[18px]">
			<h2 className="font-semibold text-zinc-950">{title}</h2>
			<p className="text-muted-foreground text-[14px]">{subTitle}</p>

			<Separator className="my-6" />
		</div>
	);
};

export default HeadingTitleItem;
